import * as questionTypes from 'modules/questionnaire/questionTypes';
import { QUESTION_ID } from 'modules/questionnaire/questionIds';

const {
  treatments: {
    questionId: TREATMENTS,
    subQuestionIds: {
      drugs_received: DRUGS_RECEIVED,
      treatment_admin: TREATMENT_ADMIN,
      treatment_end_date: TREATMENT_END_DATE,
      treatment_stop_reason: TREATMENT_STOP_REASON,
    },
  },
  procedures: {
    questionId: PROCEDURES,
    subQuestionIds: {
      procedures_received: PROCEDURES_RECEIVED,
      procedure_date: PROCEDURE_DATE,
      procedure_outcome: PROCEDURE_OUTCOME,
    },
  },
} = QUESTION_ID;

export const QUESTION_TYPE = {
  ...questionTypes,
  INTAKE_ABOUT_YOU: 'INTAKE_ABOUT_YOU',
  INTAKE_LOCATION: 'INTAKE_LOCATION',
  DRUGS_RECEIVED: 'DRUGS_RECEIVED',
  HCP_TREATMENTS: 'HCP_TREATMENTS',
};

export const MULTI_PAGES_QUESTIONS = {
  TREATMENTS,
  PROCEDURES,
};

export const MULTI_PAGES_SUB_QUESTIONS = {
  [MULTI_PAGES_QUESTIONS.TREATMENTS]: {
    DRUGS_RECEIVED,
    TREATMENT_ADMIN,
    TREATMENT_END_DATE,
    TREATMENT_STOP_REASON,
  },
  [MULTI_PAGES_QUESTIONS.PROCEDURES]: {
    PROCEDURES_RECEIVED,
    PROCEDURE_DATE,
    PROCEDURE_OUTCOME,
  },
};

export const ALL_MULTI_PAGES_QUESTIONS = [
  MULTI_PAGES_QUESTIONS.TREATMENTS,
  MULTI_PAGES_QUESTIONS.PROCEDURES,
];

export const MULTI_PAGES_QUESTIONS_TITLE = {
  [MULTI_PAGES_QUESTIONS.TREATMENTS]: MULTI_PAGES_SUB_QUESTIONS[MULTI_PAGES_QUESTIONS.TREATMENTS].DRUGS_RECEIVED,
  [MULTI_PAGES_QUESTIONS.PROCEDURES]: MULTI_PAGES_SUB_QUESTIONS[MULTI_PAGES_QUESTIONS.PROCEDURES].PROCEDURES_RECEIVED,
};
